<template>
  <div :id="this.$route.name" dir="rtl">
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">مشاهده سند</h4>
        <hr />
      </template>
      <template v-slot:content>
        <form @submit.prevent="this.$ValidForm(this)" autocomplete="off">
          <div class="row">
            <div class="col-md-12 col-12">
              <!-- <settings-button :HasAccess="false">
                <template v-slot:CtmButton>
                  <button
                    class="btn btn-orange mr-1"
                    dir="ltr"
                    data-toggle="modal"
                    data-target="#Modal-light"
                    @click.prevent="
                      $SetFilterAuto($route.name)
                      $ResetTimer()
                    "
                  >
                    <span class="mr-2">جستجــــو پیشرفته</span>
                    <span class="fas fa-magic text-dark"></span>
                  </button>
                </template>
              </settings-button> -->
              <!-- <modal-custom>
                <template v-slot:ContentModalLight>
                  <filter-card-custom :RoutName="$route.name" v-if="$store.state.renderComponentGrid"></filter-card-custom>
                </template>
              </modal-custom> -->
            </div>
          </div>
        </form>
        <div id="Filters" class="pr-3 p-2 mt-2 mb-3">
          <div class="row">
            <div id="TblDoreId" class="FilterTag col-md-2 col-12 mt-2 FilterDef">
              <small>دوره مالی </small>
              <SearchableCombo
                :defaultvalue="$session.get('DoreMaliData')[$session.get('DoreMaliData').length - 1].Id"
                :edit="false"
                :grp="11"
                @ResultCombo="ValueResultDoreMali"
                :rownumintable="3"
                :queryString="{ id: $session.get('UserInfo').tblShobeId }"
                :action="'TblCombo/GetDoreMali'"
                :method="'GET'"
                :idinput="'TblDoreId'"
                :keyItem="'TblDoreId'"
                :disabled="false"
              >
              </SearchableCombo>
              <!-- <combo :IsDefault="false" :IdEl="''" @ValueResult="ValueResultDoreMali" :IsDisabled="false" :IsLoad="true" :ActionUrl="'GetDoreMali'" :Params="$session.get('UserInfo').tblShobeId" :Op_TextDefult="'دوره مالی را انتخاب کنید'"></combo> -->
            </div>
            <div id="ShomareSanad" class="FilterTag col-md-2 col-12 mt-2 FilterDef">
              <small title="راهنما : جستجو با شماره سند ، در یک بازه مثل 1-10 ، شماره اسناد مختلف مثل 1,3,5,9"> شماره سند </small>
              <input type="text" class="form-control" dir="ltr" v-model="DataAxios.ArryfildValue.ShomareSanad" />
            </div>
            <div id="TarixSanadAz" class="FilterTag col-md-2 col-12 mt-2 FilterDef">
              <small>تاریخ سند از</small>
              <date-picker editable v-model="DataAxios.ArryfildValue.TarixSanadAz" color="dimgray"></date-picker>
              <input type="text" id="TarixSanadAz" class="d-none InputText" dir="ltr" v-model="DataAxios.ArryfildValue.TarixSanadAz" />
            </div>
            <div id="TarixSanadTa" class="FilterTag col-md-2 col-12 mt-2 FilterDef">
              <small>تاریخ سند تا</small>
              <date-picker editable v-model="DataAxios.ArryfildValue.TarixSanadTa" color="dimgray"></date-picker>
              <input type="text" id="TarixSanadTa" class="d-none InputText" dir="ltr" v-model="DataAxios.ArryfildValue.TarixSanadTa" />
            </div>
            <div id="SharhSanad" class="FilterTag col-md-6 col-12 mt-2">
              <small>جستجو در شرح سند</small>
              <div class="input-group">
                <input type="text" dir="rtl" v-model="DataAxios.ArryfildValue.SearchSharhSanad" class="form-control" aria-label="Text input with radio button" />
                <div class="">
                  <div class="">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="SharhSanad1" :value="true" v-model="IsSharhSanad" />
                      <label class="form-check-label" for="SharhSanad1">شرح سند</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="SharhSanad2" :value="true" v-model="IsSharhSanadRiz" />
                      <label class="form-check-label" for="SharhSanad2">شرح جزئیات</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="SearchMablagh" class="FilterTag col-md-6 col-12 mt-2">
              <!-- <small>جستجو در مبلغ سند</small> -->
              <div class="row">
                <div class="col-4">
                  <label for="MablaghAz">مبلغ از</label>
                  <input
                    type="text"
                    dir="ltr"
                    class="form-control 3ragham"
                    @keypress="
                      $ValidNumber($event, 20)
                      $PutCommatoInput()
                    "
                    v-model="DataAxios.ArryfildValue.MablaghAz"
                    id="MablaghAz"
                  />
                </div>
                <div class="col-4">
                  <label for="MablaghTa" class="">مبلغ تا</label>
                  <input
                    type="text"
                    class="form-control 3ragham"
                    @keypress="
                      $ValidNumber($event, 20)
                      $PutCommatoInput()
                    "
                    v-model="DataAxios.ArryfildValue.MablaghTa"
                    id="MablaghTa"
                    dir="ltr"
                  />
                </div>

                <div class="col-4 pt-5">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions2" id="rdoBedeh" :value="true" v-model="IsBedeh" />
                    <label class="form-check-label" for="rdoBedeh1">بدهکار</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions2" id="rdoBestan" :value="true" v-model="IsBestan" />
                    <label class="form-check-label" for="rdoBestan2">بستانکار</label>
                  </div>
                </div>
              </div>
            </div>
            <div id="FishNoRahgiri" class="FilterTag col-md-2 col-12 mt-4 pt-4">
              <small> شماره فیش </small>
              <input type="text" class="form-control" dir="ltr" v-model="DataAxios.ArryfildValue.FishNoRahgiri" />
            </div>
          </div>
          <div class="row mt-2 text-left mr-1">
            <button class="btn btn-success m-1 float-left" dir="ltr" @click.prevent="Search()"><span class="mr-2">جستجــو </span><span class="fa fa-search"></span></button><br />
          </div>
        </div>
        <Bnp-Grid :propsRows="rows" :propsColumn="columns" :action="true" v-if="$store.state.renderComponentGrid">
          <template slot="action-slot" slot-scope="props">
            <a class="font-weight-normal p-1 m-1 Pointer" @click="OnDetail(props.props)"> <i class="fas fa-search"></i> </a>
            <a class="font-weight-normal p-1 m-1 Pointer" @click="OnEdit(props.props)"><i class="fas fa-marker"></i> </a>
          </template>
          <template slot="action-slot2"> </template>
          <template slot="empty-results"> برای مشاهده اسناد جستجو انجام دهید </template>
          <template slot="Done" slot-scope="props" class="text-center">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input InputText" :checked="props.cell_value" id="Done" disabled />
              <label class="custom-control-label" for="Done"></label>
            </div>
          </template>
        </Bnp-Grid>
      </template>
    </Card>
  </div>
</template>
<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
// import Combo from '../../Tools/Combo.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'

export default {
  data() {
    return {
      StoreData: {
        Data: [
          {
            TblDoreId: 209684,
            ShomareSanad: '',
            TarixSanadAz: '',
            TarixSanadTa: '',
            SharhSanad: true,
            SharhSanadRiz: false,
            SearchSharhSanad: '',
            MablaghAz: '',
            MablaghTa: '',
            Bedeh: false,
            Bestan: false,
            FishNoRahgiri: '',
          },
        ],
      },
      posts: null,
      DataAxoisColumns: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: this.$session.get('UserInfo').tblUserId,
          FormName: 'frmSearchSanad',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      DataAxios: {
        ArryfildValue: {},
      },
      rows: [],
      columns: [],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [5, 10, 20, 30],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: true,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        selected_rows_info: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
          multi_column_sort: true,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm',
      },
    }
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    Card,
    BnpGrid,
    SearchableCombo,
  },
  methods: {
    OnDetail(row) {
      this.$store.state.DataSanad = row
      this.$store.state.SanadRizNew.EditData.sanad = row
      // this.$store.state.SanadRizNew.EditData= row
      this.$router.push({ name: 'SanadRizNew', params: { Status: 'View' } })
    },
    OnEdit(row) {
      this.$store.state.SanadRizNew.EditData.sanad = row
      // this.$store.state.SanadRizNew.EditData= row
      this.$router.push({ name: 'SanadRizNew', params: { Status: 'Edit' } })
    },
    ValueResultDoreMali(val) {
      this.DataAxios.ArryfildValue.TblDoreId = val == null ? 0 : val.id
    },
    Search() {
      //  console.log(this.DataAxios.ArryfildValue);
      try {
        this.DataAxios.Action = this.$route.name
        this.DataAxios.Method = 'post'

        this.$PostData(this.DataAxios).then((data) => {
          if (data.length > 0) {
            this.posts = data
            if (this.posts != null) {
              let info
              let list = []
              for (let index = 0; index < this.posts.length; index++) {
                info = this.posts[index]
                info['row'] = index + 1
                list.push(info)
              }
              this.rows = list
              this.StoreData.SanadRows = list
              this.config.pagination = true
            }
            this.$store.state.renderComponentFilterForm = false
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentFilterForm = true
              this.$store.state.renderComponentGrid = true
            })
          } else {
            this.rows = []
            this.$store.state.renderComponentFilterForm = false
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentFilterForm = true
              this.$store.state.renderComponentGrid = true
            })
            this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اطلاعاتی وجود ندارد ', 'info', 3000)
          }
        })
      } catch (error) {}
    },
  },
  created() {
    if (this.StoreData.SanadRows != null) {
      this.rows = this.StoreData.SanadRows
    }
    this.DataAxios.ArryfildValue = this.StoreData.Data[0]

    //this.AcceessButton(this.$route.name)
  },

  mounted: function () {
    // console.log(this.StoreData.Data[0].SharhSanad);
    try {
      this.columns = this.$NewGridColumns(this.DataAxoisColumns, true, true, true, true)
      this.$store.state.columns = this.columns
    } catch (error) {}
  },
  computed: {
    IsSharhSanad: {
      get() {
        return this.StoreData.Data[0].SharhSanad
      },
      set(value) {
        this.StoreData.Data[0].SharhSanad = value
        this.StoreData.Data[0].SharhSanadRiz = false
      },
    },
    IsSharhSanadRiz: {
      get() {
        return this.StoreData.Data[0].SharhSanadRiz
      },
      set(value) {
        this.StoreData.Data[0].SharhSanadRiz = value
        this.StoreData.Data[0].SharhSanad = false
      },
    },
    IsBestan: {
      get() {
        return this.StoreData.Data[0].Bestan
      },
      set(value) {
        this.StoreData.Data[0].Bestan = value
        this.StoreData.Data[0].Bedeh = false
      },
    },
    IsBedeh: {
      get() {
        return this.StoreData.Data[0].Bedeh
      },
      set(value) {
        this.StoreData.Data[0].Bedeh = value
        this.StoreData.Data[0].Bestan = false
      },
    },
  },
}
</script>
<style scoped></style>
